import { useTranslation } from 'react-i18next'

import { VIDEO_PLAYER_LABEL_KEYS } from './VideoPlayer.constants'
import { VideoPlayerLabels } from './VideoPlayer.types'

export const useVideoPlayerLabels = (
  overrides?: Partial<VideoPlayerLabels>
): VideoPlayerLabels => {
  const { t } = useTranslation('translation')

  return {
    video: t(VIDEO_PLAYER_LABEL_KEYS.video),
    play: t(VIDEO_PLAYER_LABEL_KEYS.play),
    pause: t(VIDEO_PLAYER_LABEL_KEYS.pause),
    seek: t(VIDEO_PLAYER_LABEL_KEYS.seek),
    volume: t(VIDEO_PLAYER_LABEL_KEYS.volume),
    mute: t(VIDEO_PLAYER_LABEL_KEYS.mute),
    unmute: t(VIDEO_PLAYER_LABEL_KEYS.unmute),
    playbackSpeed: t(VIDEO_PLAYER_LABEL_KEYS.playbackSpeed),
    enterFullscreen: t(VIDEO_PLAYER_LABEL_KEYS.enterFullscreen),
    exitFullscreen: t(VIDEO_PLAYER_LABEL_KEYS.exitFullscreen),
    ...overrides
  }
}
